import MuiDialog, { type DialogProps as MuiDialogProps } from '@mui/material/Dialog'
import { IconButton } from '../Buttons'
import { Close } from '../Icons'
import { DialogTitle } from './mui'

export interface DialogProps extends MuiDialogProps {
  noCloseButton?: boolean
}

export function Dialog({ noCloseButton = false, children, onClose = () => null, ...props }: DialogProps) {
  return (
    <MuiDialog onClose={onClose} {...props}>
      {!noCloseButton && (
        <DialogTitle>
          <IconButton
            aria-label='close'
            onClick={e => onClose(e, 'escapeKeyDown')}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: 'grey.900',
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
      )}
      {children}
    </MuiDialog>
  )
}
